module.exports = __webpack_public_path__ + "static/media/Brasil.e65ba522.png";